import m from 'mithril';

export default {
  view({
    attrs: {
      oninput,
      value,
      label,
      type = 'text',
      size: { sm = 12, md = 12, lg = 12 } = {},
    },
  }) {
    return m(
      `.col-sm-${sm}.col-md-${md}.col-lg-${lg}`,
      m('.form-group', [
        !label ? null : m('label', label),
        m('input.form-control.input-mask', {
          type,
          oninput: m.withAttr('value', oninput),
          value,
        }),
        m('i.form-group__bar'),
      ]),
    );
  },
};
